import { create } from 'zustand';
import { authService } from '../react-app/services/apiService.js';

export const useUserSettingsStore = create((set) => ({
  user: null,
  isLoading: true,
  error: null,

  settings: {
    theme: 'dark',
    notifications: {
      desktop: true,
      sound: true,
      mentions: true,
      replies: true,
    },
    privacy: {
      showOnlineStatus: true,
      allowDMs: 'friends',
      allowFriendRequests: true,
    },
    appearance: {
      compactMode: false,
      showAnimations: true,
      fontSize: 'normal',
      accentColor: 'blue',
    },
  },

  // Initialize user from token
  initializeUser: async () => {
    set({ isLoading: true, error: null });
    try {
      const response = await authService.getMe();
      set({ 
        user: response.data || response,
        isLoading: false 
      });
    } catch (error) {
      set({ 
        error: error.message,
        isLoading: false 
      });
    }
  },

  updateUser: (updates) =>
    set((state) => ({
      user: state.user ? { ...state.user, ...updates } : null,
    })),

  updateSettings: (path, value) =>
    set((state) => {
      const keys = path.split('.');
      const newSettings = JSON.parse(JSON.stringify(state.settings));
      let current = newSettings;
      for (let i = 0; i < keys.length - 1; i++) {
        current = current[keys[i]];
      }
      current[keys[keys.length - 1]] = value;
      return { settings: newSettings };
    }),

  toggleNotification: (key) =>
    set((state) => ({
      settings: {
        ...state.settings,
        notifications: {
          ...state.settings.notifications,
          [key]: !state.settings.notifications[key],
        },
      },
    })),

  setTheme: (theme) =>
    set((state) => ({
      settings: {
        ...state.settings,
        appearance: {
          ...state.settings.appearance,
          theme,
        },
      },
    })),
}));
